module.exports = __webpack_public_path__ + "img/wechat-icon.6882bb31.png";